import { NgClass } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  forwardRef,
} from '@angular/core';
import { ValidationDisplayDirective } from '@iupics-components/directives/validation-display.directive';
import EditTabUiComponent from '@iupics-components/standard/layouts/edit-tab-ui/edit-tab-ui.component';
import { AbstractDataContainer, AbstractDataContainerCallout } from '@iupics-manager/models/abstract-datacontainer';
import { IupicsDataField } from '@iupics-manager/models/iupics-data';
import { isNil } from 'lodash';
import { TooltipModule } from 'primeng/tooltip';
import PrimeOverlayComponent from '../../../overrided/prime-overlay/prime-overlay.component';
import FieldConflictPanelComponent from '../field-conflict-panel/field-conflict-panel.component';
import ValuePreferencePanelComponent from '../../value-preference-panel/value-preference-panel.component';
import CheckboxUiComponent from '../checkbox-ui/checkbox-ui.component';

@Component({
  selector: 'iu-input-switch-ui',
  templateUrl: './input-switch-ui.component.html',
  styleUrls: ['./input-switch-ui.component.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    TooltipModule,
    CheckboxUiComponent,
    NgClass,
    PrimeOverlayComponent,
    FieldConflictPanelComponent,
    forwardRef(() => ValuePreferencePanelComponent),
    ValidationDisplayDirective,
  ],
})
export default class InputSwitchUiComponent extends AbstractDataContainer implements OnInit, AfterViewInit {
  @Input() columnName: string;
  @Input() data: IupicsDataField;

  @ViewChild('spanRef', { static: true }) spanRef: ElementRef;

  dataContainers: AbstractDataContainerCallout;

  set checked(value: boolean) {
    this.fieldValue = this.isTriState && isNil(value) ? value : value ? 'Y' : 'N';
    this.dataChange(this.fieldValue);
  }

  get checked(): boolean | null {
    return this.isTriState && isNil(this.fieldValue) ? null : this.fieldValue === 'Y';
  }

  @Input()
  override set fieldValue(value: string | boolean) {
    if (typeof value === 'string') {
      this._fieldValue = value;
    } else {
      this._fieldValue = value ? 'Y' : 'N';
    }
  }

  override get fieldValue(): string {
    return this._fieldValue;
  }

  @ViewChild('opConflict', { static: true })
  opConflict: FieldConflictPanelComponent;

  isSwitchField = true;

  ngOnInit(): void {
    super.ngOnInit();
    if (!this.isStandalone) {
      if (this.data && this.data.label) {
        this.label = this.data.label;
      }
      if (this.cssClass !== undefined) {
        this.cssGrid = this.cssClass;
      }
    }
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    if (!this.isStandalone) {
      let parentComp = this.DOMParentComponent;
      while (parentComp && !(parentComp instanceof EditTabUiComponent)) {
        parentComp = parentComp.DOMParentComponent;
      }
      if (parentComp instanceof EditTabUiComponent) {
        this.dataContainers = new AbstractDataContainerCallout(parentComp.dataContainers);
      }
      // permet de setter les valeurs venant de l'url d'un process
      if (this.parentProcess) {
        const value = this.parentProcess.paramsMap.get(this.data.columnName);
        if (value !== undefined) {
          this.checked = (value as string).toUpperCase() === 'Y';
        }
      }
    }
  }

  showConflictPanel(ev): void {
    this.opConflict.toggle(ev);
  }

  labelClick(event): void {
    if (!this.isReadOnly) {
      if (event) {
        event.stopPropagation();
      }
      this.checked = !this.checked;
    }
  }
}
